<template>
    <div class="column is-12 academies-summary">
        <h5 class="is-size-5 mb-2">{{ translate("common.summary") }}</h5>

        <TransitionGroup v-if="academyResults.length > 0" tag="div" name="fade">
            <div class="box is-hoverable is-condensed" :key="academyResult.academyId" v-for="academyResult in academyResults">
                <AcademySummaryRow :academy-result="academyResult" />

                <AffiliationsMergedResults :parent-academy-id="academyResult.academyId" />
            </div>
        </TransitionGroup>

        <div v-else>
            <Notification class="is-warning">
                <span class="icon">
                    <i class="fa fa-exclamation-triangle" />
                </span>
                <span>{{ translate("page.admin_academy_results.no_results") }}</span>
            </Notification>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import Notification from "../Common/Notification.vue";
    import AcademySummaryRow from "./AcademySummaryRow.vue";
    import AffiliationsMergedResults from "./AffiliationsMergedResults.vue";
    import { CalculatedAcademyResultsResponse } from "../Api/competitorResultsApi";
    import { useAcademyResultsStore } from "./academyResultsStore";

    const store2 = useAcademyResultsStore();

    const academyResults = computed<CalculatedAcademyResultsResponse["mainResults"]>(() => store2.academyResults);
</script>

<style scoped>
    .fade-move,
    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
        transform: scaleY(0.01) translate(30px, 0);
    }

    .fade-leave-active {
        position: absolute;
    }
</style>
